import { Component, ErrorHandler, Inject, Injectable, NgZone, OnInit } from "@angular/core";
import { MatSnackBar, MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";

@Injectable()
export class AllErrorHandler implements ErrorHandler{
  gloablError:any;
  constructor(private _snackBar: MatSnackBar,private ngZone:NgZone) {}

  handleError(error: any){
    //this._snackBar.openFromComponent(NotificationComponent,{duration:5000,data:"An Error occurred during this operation",verticalPosition:'bottom'});
console.log(error);
  this.ngZone.run(() => {
  setTimeout(()=>{
    if(typeof error.message === 'string' && error.message.length!==0){
    this._snackBar.open($localize `Error occurred. Error code: ${error?.message}`,"",
    {
      duration:3000,
      verticalPosition:"bottom",
      horizontalPosition:"center"
    });
  }
  },0);
  })
}
}
@Component({
  selector: 'example',
  templateUrl: 'generalnotification.html',
})
export class NotificationComponent implements OnInit {
constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any){}
ngOnInit(): void {}
}
